<template>
	<div class="main-cont">
    <div class="wrapper-item">
			<img class="animated slideInDown" :src="electlogo"/> 
			<h1 class="animated bounceInLeft" style="font-family: bold; font-size: 38px;">{{ prod_name }}</h1>
			<br>
			<h2 class="enf">{{ prod_desc }}</h2>
      <br>
      <h1>El proceso de votación ha CONCLUIDO. Gracias a todos por su confianza!</h1>
      <h1>Pronto anunciaremos nuestros planes a futuro</h1>
       <div>
        <a style="text-decoration: none;" href="https://play.google.com/store/apps/details?id=electchain.electchain">
          <img class="bounceInUp googleapp" :src="googleapp"/>
          <p>Puedes consultar los resultados finales desde la App</p>
        </a>
      </div>
			<br>
			<h3 class="animated fadeIn">{{ prod_stat }}</h3>
			<h3 class="animated fadeIn">{{ prod_resu }}</h3>
			<br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      prod_name: '¡ELECTCHAIN!',
	    prod_desc: 'Por una democracia más confiable en México',
	    prod_stat: 'Electchain construye un cambio en la forma como los procesos electorales se llevan a cabo.',
	    prod_resu: 'Es un proyecto hecho por ciudadanos Mexicanos para ciudadanos Mexicanos.',
      electlogo: require('./assets/logo.png'),
      googleapp: require('./assets/googleplay.png'),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import  './navbar/animate.css';
.main-cont{
  height: 100%;
  display: flex;
  align-items: center;
  background-color: transparent;
}
.wrapper-item{
	display: block;
	margin: 0;
	width: 100%;
	position: relative;
}
.googleapp{
    width: 580px;
  }
img{
  width: 240px;
  height: 240px;
}
h1{
  font-size: 28px;
}
h2.res{
  padding: 15px;
}
h2.enf{
  font-weight: bold;
}

@media screen and (min-width: 480px) and (max-width: 820px){
  .googleapp{
    height: 128px;
    width: 320px;
  }
  .main-cont{
    font-size: 16px;
  }
}
@media only screen and (max-width: 480px){
 .main-cont{
    font-size: 14px;
  }
  .googleapp{
    height: 104px;
    width: 240px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue